<div class="eidos-filter-wrapper eidos-popup-list-selector-filter-wrapper">
  <p class="eidos-filter-label eidos-popup-list-selector-filter-label" *ngIf="config.label">{{ config.label }}</p>

  <core-popup-list-selector class="dx-field-value w-100" *ngIf="popupListSelectorConfig"
    [config]="popupListSelectorConfig" [(value)]="value">
    </core-popup-list-selector>

</div>
